<template>
  <a-modal
    title="消息列表"
    width="40%"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :maskClosable="false"
    :keyboard="false"
    :footer="null"
    :destroyOnClose="true"
    @cancel="handleClose"
  >
    <div class="message-modal">
      <!-- 搜索和过滤区域 -->
      <div class="message-filter">
        <a-select
          v-model="params.izView"
          clearable
          placeholder="消息状态"
          class="filter-select"
        >
          <a-select-option label="全部" value="">全部</a-select-option>
          <a-select-option label="已读" value="1">已读</a-select-option>
          <a-select-option label="未读" value="0">未读</a-select-option>
        </a-select>

        <a-input
          v-model="params.content"
          clearable
          placeholder="搜索消息内容"
          class="filter-input"
        />

        <a-button type="primary" @click="handleSearch">搜索</a-button>
        <a-popconfirm
          title="确定将所有消息标记为已读吗?"
          ok-text="确定"
          cancel-text="取消"
          @confirm="handleMarkAllRead"
          @cancel="handleCancel"
        >
          <a-button type="primary">一键已读</a-button>
        </a-popconfirm>
        <a-popconfirm
          title="确定将所有已读消息清空吗?"
          ok-text="确定"
          cancel-text="取消"
          @confirm="handleClearRead"
          @cancel="handleCancelClear"
        >
          <a-button type="primary">一键清空</a-button>
        </a-popconfirm>
      </div>

      <!-- 消息列表 -->
      <div class="message-list" v-loading="loading">
        <template v-if="messageList.length > 0">
          <ul class="message-items">
            <li
              v-for="(item, index) in messageList"
              :key="`message-${index}`"
              class="message-item"
              :class="{ 'is-read': item.izView == 1 }"
              @click="handleMessageClick(item)"
            >
              <div class="message-content">
                {{ item.content }}
                <span v-if="item.izView == 0" class="unread-badge"></span>
              </div>
              <div class="message-time">{{ item.createTime }}</div>
            </li>
          </ul>
        </template>

        <div v-else class="empty-message">
          <a-empty description="暂无消息" />
        </div>
      </div>

      <!-- 分页 -->
      <div class="message-pagination">
        <a-pagination
          :page-size="params.pageSize"
          :current="params.pageNo"
          @change="handlePageChange"
          :total="total"
        />
      </div>
    </div>
  </a-modal>
</template>
  
  <script>
import { getAction, postAction } from "@/api/index";

export default {
  name: "MessageModal",
  data() {
    return {
      visible: false,
      confirmLoading: false,
      loading: false,
      messageList: [],
      total: 0,
      // 1 学校发起审核人收到的审核消息 2 审核通过后 学校收到的审核详情消息 3 评分人收到的审核通过信息添加的消息 4 最高审核人收到的审核通过信息添加的消息
      roleMap: {
        "school-role": 2,
        "teacher-role": 2,
        "audit-role": 1,
        "score-role": 3,
        "education-role": 4,
      },
      params: {
        pageNo: 1,
        pageSize: 10,
        izView: "",
        content: "",
      },
    };
  },
  methods: {
    init() {
      this.visible = true;
      this.fetchMessages();
    },

    handleClose() {
      this.visible = false;
      this.$emit("fetchMessagesCount");
    },

    handlePageChange(page, pageSize) {
      console.log("🚀 ~ handlePageChange ~ page:", page, pageSize);
      this.params.pageNo = page;
      this.fetchMessages();
    },

    handleSearch() {
      this.params.pageNo = 1;
      this.fetchMessages();
    },

    async fetchMessages() {
      this.loading = true;
      console.log("this.$store.state.role", this.$store.state);
      console.log(
        "this.$store.state.role",
        this.roleMap[this.$store.state.role]
      );

      try {
        const params = {
          ...this.params,
          type: this.roleMap[this.$store.state.role],
        };

        const res = await getAction("/audit/lxAuditMessage/queryList", params);

        console.log("🚀 ~ fetchMessages ~ res.data:", res);
        if (res?.code == 200) {
          this.messageList = res.result?.records || [];
          this.total = res.result?.total || 0;
        }
      } catch (error) {
        console.error("获取消息列表失败:", error);
        this.$message.error("获取消息列表失败");
      } finally {
        this.loading = false;
      }
    },

    async handleMarkMessageRead(id) {
      try {
        const params = { id, izView: 1 };
        // 实际调用API
        await postAction("/audit/lxAuditMessage/edit", params);
        this.$message.success("消息已标记为已读");
        const findIndex = this.messageList.findIndex((item) => item.id == id);
        if (findIndex > -1) {
          this.messageList[findIndex].izView = 1;
        }
      } catch (error) {
        console.error("标记消息为已读失败:", error);
        this.$message.error("标记消息为已读失败");
      }
    },

    handleMessageClick(item) {
      // 点击未读消息仅标记为已读，不打开详情
      if (item.izView == 0) {
        this.handleMarkMessageRead(item.id);
      }
    },

    async handleMarkAllRead() {
      try {
        const idList = this.messageList.map((item) => item.id).join(",");
        const params = {
          ids: idList,
        };
        // 实际调用API
        await postAction("/audit/lxAuditMessage/editBatchIzView", params);
        this.$message.success("所有消息已标记为已读");
        this.fetchMessages();
      } catch (error) {
        console.error("标记消息为已读失败:", error);
        this.$message.error("标记消息为已读失败");
      }
    },
    handleCancel() {
      this.$message.info("已取消操作");
    },
    async handleClearRead() {
      try {
        const idList = this.messageList
          .filter((item) => item.izView == 1)
          .map((item) => item.id)
          .join(",");
        const params = {
          ids: idList,
        };
        // 实际调用API
        await postAction("/audit/lxAuditMessage/editBatchIzClear", params);
        this.$message.success("所有已读消息已清空");
        this.fetchMessages();
      } catch (error) {
        console.error("清空已读消息失败:", error);
        this.$message.error("清空已读消息失败");
      }
    },
    handleCancelClear() {
      this.$message.info("已取消清空操作");
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.message-modal {
  padding: 16px;
}

.message-filter {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  gap: 10px;

  .filter-select {
    width: 120px;
  }

  .filter-input {
    width: 200px;
    flex: 1;

    ::v-deep .el-input__inner {
      height: 32px;
      line-height: 32px;
    }
  }

  .el-button {
    height: 32px;
    padding: 0 15px;
    background-color: #1890ff;
    border-color: #1890ff;
  }
}

.message-list {
  min-height: 300px;
  position: relative;
}

.message-items {
  list-style: none;
  padding: 0;
  margin: 0;
}

.message-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background-color: #f5f5f5;
  }

  &.is-read {
    color: #999;
  }
}

.message-content {
  flex: 1;
  position: relative;
  padding-right: 10px;
}

.message-time {
  color: #999;
  font-size: 12px;
  white-space: nowrap;
}

.unread-badge {
  display: inline-block;
  width: 6px;
  height: 6px;
  background-color: #f5222d;
  border-radius: 50%;
  margin-left: 6px;
  vertical-align: middle;
}

.empty-message {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
}

.message-pagination {
  margin-top: 20px;
  text-align: center;
}
</style>